var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.handleBlur,
          expression: "handleBlur",
        },
      ],
      staticClass: "form",
      attrs: { id: "search", role: "search" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.search.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { attrs: { id: "search__form" } }, [
        _c(
          "label",
          { staticClass: "sr-only", attrs: { for: "search__query" } },
          [_vm._v("Search site")]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.query,
              expression: "query",
            },
          ],
          ref: "input",
          staticClass: "input",
          attrs: {
            id: "search__query",
            type: "search",
            name: "query",
            placeholder: "Search site",
            autocomplete: "off",
          },
          domProps: { value: _vm.query },
          on: {
            focus: _vm.handleFocus,
            input: function ($event) {
              if ($event.target.composing) return
              _vm.query = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            attrs: { type: "submit", "aria-label": "Search" },
          },
          [
            _vm.$wait.is("loading_search_results")
              ? _c("Spinner", {
                  attrs: { height: 20, width: 20, color: "#fff" },
                })
              : _c("SvgIcon", { attrs: { icon: "search" } }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.showResults
        ? _c("div", { attrs: { id: "search__results" } }, [
            _vm.results.opportunities && _vm.results.opportunities.length > 0
              ? _c("section", { staticClass: "result-category" }, [
                  _c(
                    "header",
                    { staticClass: "result-category__header" },
                    [
                      _c("span", [_vm._v("Opportunities")]),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { attrs: { to: `/search/${_vm.query}/opportunities` } },
                        [_vm._v("View All")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "result-category__results" },
                    _vm._l(_vm.results.opportunities, function (opportunity) {
                      return _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "view-opportunity",
                                  params: { opportunity_id: opportunity.id },
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.formatOppName(opportunity)) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.results.madds && _vm.results.madds.length > 0
              ? _c("section", { staticClass: "result-category" }, [
                  _c(
                    "header",
                    { staticClass: "result-category__header" },
                    [
                      _c("span", [_vm._v("MADDs")]),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { attrs: { to: `/search/${_vm.query}/madds` } },
                        [_vm._v("View All")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "result-category__results" },
                    _vm._l(_vm.results.madds, function (madd) {
                      return _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "view-madd",
                                  params: { madd_id: madd.id },
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(madd.companyName) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.results.users && _vm.results.users.length > 0
              ? _c("section", { staticClass: "result-category" }, [
                  _c(
                    "header",
                    { staticClass: "result-category__header" },
                    [
                      _c("span", [_vm._v("Users")]),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        { attrs: { to: `/search/${_vm.query}/users` } },
                        [_vm._v("View All")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "result-category__results" },
                    _vm._l(_vm.results.users, function (user) {
                      return _c(
                        "li",
                        [
                          _c(
                            "router-link",
                            {
                              attrs: {
                                to: {
                                  name: "view-user",
                                  params: { user_id: user.id },
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(user.name) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }